import { fetchBulkIssues } from '@atlassian/jira-issue-view-services/src/issue/issue-fetch-server';
import type { BaseUrl, IssueKey } from '@atlassian/jira-shared-types';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (baseUrl: BaseUrl, issueKeys: IssueKey[]) =>
	fetchBulkIssues(baseUrl, issueKeys, ['assignee']).toPromise();
